<template>
  <v-expand-transition>
    <div v-if="active" class="my-5">
      <v-row>
        <v-col class=" py-0">
          <DashboardCard :title="totals.valueMax" subtitle="Valor Total" icon="mdi-cash-100" color="#8bc34a" size="80px" :animated="true" />
        </v-col>
        <v-col class=" py-0">
          <DashboardCard
            :title="totals.valueMean"
            subtitle="Ticket Médio"
            icon="mdi-cash-multiple"
            color="#66BB6A"
            size="80px"
            :animated="true"
          />
        </v-col>
        <v-col class=" py-0">
          <DashboardCard :title="totals.count" subtitle="Total de Pedidos" icon="mdi-cart" color="#2E7D32" size="80px" :animated="false" />
        </v-col>
      </v-row>
    </div>
  </v-expand-transition>
</template>

<script>
import DashboardCard from '@/components/DashboardCard'
export default {
  name: 'TheOrderTotals',
  components: {
    DashboardCard,
  },
  props: {
    totals: Object,
    active: Boolean,
  },
}
</script>

<style></style>
